module.exports = __webpack_public_path__ + "img/bahrain.49837f36.svg";